import { combineReducers } from "redux";
import axios from "axios";
import _ from 'lodash';
import { API } from "../../../../../../const";
import { Service } from "../../../../../service/service"
import { unAuthorized } from '../../../../../auth/Auth.ducks'
import { fetchKids } from "../../../Kids-list.ducks";

// Petitcoint actions

export const POST_PETITCOIN_PENDING = "POST_PETITCOIN_PENDING";
export const POST_PETITCOIN_REJECTED = "POST_PETITCOIN_REJECTED";
export const POST_PETITCOIN_FULFILLED = "POST_PETITCOIN_FULFILLED";

export const GET_PETITCOIN_PENDING = "GET_PETITCOIN_PENDING";
export const GET_PETITCOIN_REJECTED = "GET_PETITCOIN_REJECTED";
export const GET_PETITCOIN_FULFILLED = "GET_PETITCOIN_FULFILLED";

export const PUT_PETITCOIN_PENDING = "PUT_PETITCOIN_PENDING";
export const PUT_PETITCOIN_REJECTED = "PUT_PETITCOIN_REJECTED";
export const PUT_PETITCOIN_FULFILLED = "PUT_PETITCOIN_FULFILLED";

export const DELETE_PETITCOIN_PENDING = "DELETE_PETITCOIN_PENDING";
export const DELETE_PETITCOIN_REJECTED = "DELETE_PETITCOIN_REJECTED";
export const DELETE_PETITCOIN_FULFILLED = "DELETE_PETITCOIN_FULFILLED";
const loading = (state = {}, { type }) => {
  switch (type) {
    case POST_PETITCOIN_PENDING:
    case GET_PETITCOIN_PENDING:
    case PUT_PETITCOIN_PENDING:
    case DELETE_PETITCOIN_PENDING:

      return true;
    case POST_PETITCOIN_REJECTED:
    case POST_PETITCOIN_FULFILLED:
    case GET_PETITCOIN_REJECTED:
    case GET_PETITCOIN_FULFILLED:
    case PUT_PETITCOIN_REJECTED:
    case PUT_PETITCOIN_FULFILLED:
    case DELETE_PETITCOIN_REJECTED:
    case DELETE_PETITCOIN_FULFILLED:
      return false;
    default:
      return false;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_PETITCOIN_PENDING:
    case POST_PETITCOIN_FULFILLED:
    case GET_PETITCOIN_PENDING:
    case GET_PETITCOIN_FULFILLED:
    case PUT_PETITCOIN_PENDING:
    case PUT_PETITCOIN_FULFILLED:
    case DELETE_PETITCOIN_PENDING:
    case DELETE_PETITCOIN_FULFILLED:
      return null;
    case POST_PETITCOIN_REJECTED:
    case GET_PETITCOIN_REJECTED:
    case PUT_PETITCOIN_REJECTED:
    case DELETE_PETITCOIN_REJECTED:

      return payload;
    default:
      return null;
  }
};

const data = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_PETITCOIN_FULFILLED:
    case GET_PETITCOIN_FULFILLED:
    case PUT_PETITCOIN_FULFILLED:
    case DELETE_PETITCOIN_FULFILLED:


      return _.isEmpty(payload.data) ? null : payload.data;

    case POST_PETITCOIN_PENDING:
    case GET_PETITCOIN_PENDING:
    case PUT_PETITCOIN_PENDING:
    case DELETE_PETITCOIN_PENDING:
      return null;
    case POST_PETITCOIN_REJECTED:
    case GET_PETITCOIN_REJECTED:
    case PUT_PETITCOIN_REJECTED:
    case DELETE_PETITCOIN_REJECTED:
      return null;

    default:
      return state;
  }
};

// Petitcoint reducer
export default combineReducers({ loading, error, data });

export const postPetitcoinSimple = (tok, id, data) => {
  return (dispatch) => {
    const response = Service.post(`${API}api/enfant/creche/enfants/${id}/petits-coins`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: POST_PETITCOIN_FULFILLED, payload: res })
      dispatch(fetchKids(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: POST_PETITCOIN_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const getPetitCoinEvent = (tok, idEvent) => {
  return (dispatch) => {
    const response = Service.get(`${API}api/enfant/creche/petits-coins/${idEvent}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: GET_PETITCOIN_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: GET_PETITCOIN_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const updatePetitCoinEvent = (tok, idEvent, data) => {
  return (dispatch) => {
    const response = Service.put(`${API}api/enfant/creche/petits-coins/${idEvent}`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: PUT_PETITCOIN_FULFILLED, payload: res })
      dispatch(fetchKids(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: PUT_PETITCOIN_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const DeletePetitCoinEvent = (tok, idEvent) => {
  return (dispatch) => {
    const response = Service.deleteOne(`${API}api/enfant/creche/petits-coins/${idEvent}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: DELETE_PETITCOIN_FULFILLED, payload: res })
      dispatch(fetchKids(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: DELETE_PETITCOIN_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}